/** @file Where a dragged tree row lands on a target row: the top quarter, the bottom quarter, or into it. */

/** Before the row, into it (as a child), or after it. */
export type DropWhere = 'before' | 'into' | 'after';

/** `y` is the pointer's offset from the row's top edge in px; rows are `height` px tall. */
export function dropPosition(y: number, height: number): DropWhere {
  if (y < height / 4) return 'before';
  return y > (height * 3) / 4 ? 'after' : 'into';
}
